/* globals window, _, Q */
(function() {
	"use strict";

	var APP = {
		VERSION: "2.0.0"
	};

	// Expose  to the window
	window.APP = APP;

}());
